<form [formGroup]="form" class="section__hotel">
  <div class="section__hotel__tags">
    <app-pop-up-pasajero
      #popUp
      (emitDistribution)="distribution = $event"
      (emitDistributionObject)="distributionObject = $event"
      [nroAdultos]="2"
    ></app-pop-up-pasajero>
  </div>
  <div class="section__hotel__inputs">
    <div class="section__hotel__inputs__group">
      <app-autocomplete-dropdown
        (selectItem)="onDestinationSelect($event)"
        [control]="destination"
        [showClearInput]="false"
        [showLoader]="destinationLoading"
        [suggestions]="destinationSuggestions"
        id="origen-autocomplete"
        placeholder="Origen"
      ></app-autocomplete-dropdown>
    </div>
    <app-input-range #childDates [typeFlight]="-1"></app-input-range>
    <app-button
      (buttonClick)="searchAlojamiento()"
      [isFullWidth]="true"
      buttonClass="px-4"
      title="Buscar"
    >
      <i aria-label="Buscar" class="custom-icon icon-search"></i>
      <span class="d-lg-none ms-2">Buscar</span>
    </app-button>
  </div>
</form>
